<template>
    <div class="MaddAdvisers">
        <div class="pic">
            <img src="../../assets/img/recruit-bg.png" alt="">
            <p>加入我们，一起开创财务的新未来</p>
            <mt-button class="button" @click="apply" type="danger">预约报名</mt-button>
        </div>
        <div class="customer-main">
            <div class="word">
                <p>互联智能，推动劳力服务向知识服务转移，专业人员迎来了自由流动和创作的时代。分布在中小微企业1,200万财务从业者，缺少自由流动和创造激励的机制和平台，用户得不到响应时代变化的价值服务，从者人员收入和地位得不到提升。</p>
                <p>橙蟹为之而生，八年多的披荆斩棘，时代的大变化，行业同仁的共同探讨，我们摸索出了一条实践之路。重新定义了从业人员应具备怎样的技能，采取怎样的运作方式，来服务客户的变化需求。一批分布不同行业，不同规模的忠实客户群，一系列适应不同性格，不同技能企业主的产品与服务，一支自营与平台顾问相互协同的营销与交付体系。
				</p>
                <p>我们需要更多具有创新思维的同行加入我们，一起开创财务的新未来。</p>
            </div>
            <h2>加入流程</h2>
            <div class="customer-pic">
                <img src="../../assets/img/home－image－3.png" alt="">
            </div>
            <h2>公开课</h2>
            <div class="customer-pic">
                <img src="../../assets/img/gkk.jpg" alt="">
            </div>
            <h2>训练营</h2>
            <div class="customer-pic">
                <img src="../../assets/img/xly.jpg" alt="">
            </div>

            <h2>财务顾问团队<p>不仅需要好财务，更需要有价值的财务</p>
            </h2>
            <div class="group">
                <div v-for="(item,i) in groupList" :key="i" class="groupBox">
                    <img :src="item.imgPath" alt="">
                </div>
            </div>

            <h2>往期回顾</h2>
            <div class="review" v-for="item in reviewList" :key="item.reviewTrainId">
                <img :src="url+item.reviewTrainImg" alt="">
                <h4>{{item.title}}</h4>
                <a :href="item.reviewTrainUrl" target="_blank">查看详情></a>
            </div>
            <div v-if="this.reviewList.length !== this.currentTotal" class="view-more" @click="loadMore">查看更多</div>
            <div v-else class="view-more">暂无更多数据...</div>
        </div>
    </div>
</template>

<script>
import { revieWtrain } from '../../api/api.js'
export default {
  name: 'MaddAdvisers',
  created () {
    this.getPageList()
  },
  data () {
    return {
      url: this.GLOBAL.picURL,
      groupList: [
        {
          imgPath: require('../../assets/img/counselor－1.png'),
          title: '深谋远虑的大师顾问',
          rank: ' ★ ★ ★ ★ ★',
          client: '200+家',
          duration: '60月',
          workYears: '14年',
          credential: 'CPA/MBA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－2.png'),
          title: '学霸型的知性顾问',
          rank: ' ★ ★ ★ ★ ★',
          client: '400+家',
          duration: '60月',
          workYears: '9年',
          credential: 'CPA/CMA/TA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－4.png'),
          title: '百科型暖男顾问',
          rank: ' ★ ★ ★ ★ ',
          client: '43家',
          duration: '40月',
          workYears: '13年',
          credential: 'CMA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－3.png'),
          title: '聪慧型的御姐顾问',
          rank: ' ★ ★ ★ ★ ',
          client: '100家',
          duration: '31月',
          workYears: '9年',
          credential: 'ACCA/TA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－6.png'),
          title: '沉稳型的大叔顾问',
          rank: ' ★ ★ ★ ★ ',
          client: '150+家',
          duration: '60月',
          workYears: '26年',
          credential: 'CMA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－5.png'),
          title: '睿智形的跑男顾问',
          rank: ' ★ ★ ★ ★',
          client: '86家',
          duration: '23月',
          workYears: '21年',
          credential: 'CMA/MBA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－8.jpg'),
          title: '足智多谋的才人顾问',
          rank: ' ★ ★ ★ ★ ★ ',
          client: '21家',
          duration: '12月',
          workYears: '17年',
          credential: 'CMA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－10.jpg'),
          title: '智慧型的才女顾问',
          rank: ' ★ ★ ★ ★ ★ ',
          client: '28家',
          duration: '36月',
          workYears: '19年',
          credential: 'CPA、SIFM',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－9.jpg'),
          title: '细致型的淑女顾问',
          rank: ' ★ ★ ★ ★',
          client: '35家',
          duration: '26月',
          workYears: '16年',
          credential: 'CPA',
          show: false
        },
        {
          imgPath: require('../../assets/img/counselor－7.png'),
          title: '友善型的表姐顾问',
          rank: ' ★ ★ ★ ',
          client: '72家',
          duration: '25月',
          workYears: '10年',
          credential: 'CMA',
          show: false
        }],
      reviewList: [],
      pageNum: 1,
      currentTotal: 0
    }
  },
  methods: {
    apply () {
      this.$router.push('/Msign')
    },
    getPageList () {
      revieWtrain({
        pageNum: this.pageNum,
        pageSize: 3
      }).then(res => {
        this.currentTotal = res.data.data.total
        for (let i = 0; i < res.data.data.list.length; i++) {
          if (res.data.data.list[i].reviewTrainStatus == '1') {
            this.reviewList.push(res.data.data.list[i])
          }
        }
      })
    },
    loadMore () {
      ++this.pageNum
      this.getPageList()
    }
  }
}
</script>

<style scoped lang='scss'>
    // 图片
    .pic {
        height: 21.428571rem;
        // height: 150px;
        text-align: center;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        p {
            font-size: 18px;
            color: #ffffff;
            position: absolute;
            margin-top: -26%;
            margin-left: 14%;
        }

        .button {
            position: absolute;
            background-color: #ff5112;
            color: #ffffff;
            margin-top: -18%;
            margin-left: -10%;
            border: none;
        }
    }

    // 主体内容
    .customer-main {
        .word {
            padding: 1% 4%;
            background-color: #f5f5f5;

            p {
                padding: 3% 0;
                text-indent: 2em;
            }
        }

        h2 {
            text-align: center;
            padding: 4% 0;
            color: #2e324f;

            P {
                font-size: 12px;
                font-weight: normal;
            }
        }

        .customer-pic {
            img {
                width: 100%;
            }
        }

        .groupBox {
            display: inline-block;
            margin: 1% 1%;
            width: 48%;

            img {
                width: 100%;
            }
        }

        .review {
            padding: 2% 4%;

            img {
                width: 100%;
            }

            h4 {}

            a {}
        }

        .view-more {
            text-align: center;
            margin-bottom: 2%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/MaddAdvisers.vue